import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export const getDailyVerse = () => {
  return axios.get(`/bible/daily-verse`);
};

export const useDailyVerse = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["daily-verse"],
    queryFn: getDailyVerse,
    select: data => data.result,
    staleTime: ONE_DAY_IN_MS,
    cacheTime: ONE_DAY_IN_MS
  });
};
